<template>
  <div class="asistencia">
    <v-form ref="formasistencia" v-model="valid" @submit.prevent="actualizarPersona()">
      <v-container>
        <v-layout row wrap>
          <v-flex xs12 md4>
            <v-flex xs12><h2>Jornada</h2></v-flex>
            <v-flex xs12>
                <v-combobox
                v-model="evento"
                :items="eventos"
                item-value="id"
                item-text="evento"
                label="Selecciona el evento"
                :rules="[v => !!v || 'La jornada es requerida']"
                ></v-combobox>
            </v-flex>
          </v-flex>
          <v-flex xs12 md4>
            <v-flex xs12><h2>Servicio</h2></v-flex>
            <v-flex xs12>
                <v-combobox
                v-model="servicio"
                :items="servicios"
                item-value="id"
                item-text="servicio"
                label="Selecciona el servicio"
                :rules="[v => !!v || 'El servicio es requerido']"
                ></v-combobox>
            </v-flex>
          </v-flex>
          <v-flex xs12 md4>
            <v-flex xs12><h2>Persona</h2></v-flex>
            <v-autocomplete
              v-model="persona"
              :items="personas"
              :loading="personaLoading"
              :search-input.sync="searchPersona"
              item-text="completo"
              item-value="id"
              label="Persona"
              placeholder="Busca a la persona"
              return-object no-filter
              autocomplete
              :rules="[v => !!v || 'La persona es requerida.']"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12><h2>Datos faltantes</h2></v-flex>
          <v-flex xs12 md6>
            <v-autocomplete
              v-model="municipio"
              :items="municipios"
              :loading="municipioLoading"
              :search-input.sync="searchMunicipio"
              item-text="municipio"
              item-value="id"
              label="Municipio"
              placeholder="Busca el municipio"
              return-object no-filter
              autocomplete
              :rules="[v => !!v || 'El municipio es requerido.']"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 md6>
            <v-autocomplete
              v-model="localidad"
              :items="localidades"
              :loading="localidadLoading"
              :search-input.sync="searchLocalidad"
              hide-no-data
              hide-selected
              item-text="localidad"
              item-value="id"
              label="Localidad"
              placeholder="Busca la localidad"
              return-object
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 md6>
            <v-text-field
              v-model="persona.curp"
              :counter="18"
              label="Curp"
              required
              :rules=curpRules
              @keyup="obtenFecha()"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md6>
            <v-text-field
              v-model="persona.fechaNacimiento"
              :counter="10"
              label="Fecha de Nacimiento (YYYY-MM-DD)"
              :rules=fechaNacimientoRules
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md4>
            <v-text-field
              v-model="persona.telefono"
              :counter="10"
              label="Telefono"
              :rules="[
                v => !!v || 'El telefono es requerido.', 
                v => /(^undefined$)|(?:^$)|\d+|(?:S\/N)|(?:s\/n)/.test(v) || 'Solo se aceptan números.']"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md8>
            <!-- <v-flex xs12><h2>Observación</h2></v-flex> -->
            <v-flex xs12>
              <v-textarea
                  name="input-7-1"
                  label="Observación"
                  v-model="observacion"
                  placeholder="observacion"
                  rows="1"
              ></v-textarea>
            </v-flex>
          </v-flex>
          <v-flex xs12 md12>
            <v-btn color="info" type="submit" block>Guardar</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import swal from "sweetalert2";
import axios from "axios";
import GlogalJS from '../mixins/GlobalJs';

export default {
  name: 'evento',
  components: {},
  mixins: [GlogalJS],
  data() {
    return {
      valid: false,
      eventos: [],
      evento: null,
      servicios: [],
      servicio: null,
      personas: [],
      persona: {
        nombre: '',
        primerApellido: '',
        segundoApellido: '',
        cargo: null,
        curp: null,
        fechaNacimiento: null,
        telefono: null,
        codigoPostal: null,
        diagnostico: null,
        responsable: {
          nombre: null,
          primerApellido: null,
          segundoApellido: null
        }
      },
      search: null,
      searchPersona: null,
      searchServicios: null,
      searchMunicipio: null,
      searchLocalidad: null,
      evento: null,
      municipios: [],
      municipio: null,
      observacion: null,
      eventoLoading: false,
      servicioLoading: false,
      personaLoading: false,
      municipioLoading: false,
      localidadLoading: false,
      localidades: [],
      localidad: null,
      localidadLoading: false,
      curpRules: [
        v => !!v || "La CURP es requerida.",
        v => /^[A-Za-z]{1}[AEIOUXaeioux]{1}[A-Za-z]{2}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[HMhm]{1}(AS|BC|BS|CC|CS|CH|CL|CM|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE|as|bc|bs|cc|cs|ch|cl|cm|df|dg|gt|gr|hg|jc|mc|mn|ms|nt|nl|oc|pl|qt|qr|sp|sl|sr|tc|ts|tl|vz|yn|zs|ne)[B-DF-HJ-NP-TV-Z-b-df-hj-np-tv-z]{3}[0-9A-Za-z]{1}[0-9]{1}$/i.test(v) 
        || "La CURP no es válida."
      ],
      fechaNacimientoRules : [
        v => !!v || "La CURP es requerida.",
        v => /^[0-9]{4}[/-][0-9]{2}[/-][0-9]{2}$/i.test(v) 
        || "La fecha no es válida."
      ]
    }
  },
  watch: {
    searchServicio (val) {
      if (val == null) return
      if (this.servicioLoading) return
      this.servicioLoading = true
      if (val == null) return;
      fetch(`${this.server_api}/eventos/${this.evento.id}/servicios?search=${val}`)
        .then(res => res.json())
        .then(res => {
          this.personas = res
        })
        .catch(err => {
          //console.log(err)
        })
        .finally(() => (this.servicioLoading = false))
    },
    searchPersona (val) {
      if (val == null || val.length < 4) return
      if (this.personaLoading) return
      this.personaLoading = true
      fetch(`${this.server_api}/jornadas/preregistro?search=${val}`)
        .then(res => res.json())
        .then(res => {
          this.personas = res
        })
        .catch(err => {
          //console.log(err)
        })
        .finally(() => (this.personaLoading = false))
    },
    searchMunicipio (val) {
      if (val == null || val.length < 3) return
      if (this.municipioLoading) return
      this.municipioLoading = true
      fetch(`${this.server_api}/municipios?search=${val}`)
        .then(res => res.json())
        .then(res => {
          this.municipios = res
        })
        .catch(err => {
          //console.log(err)
        })
        .finally(() => (this.municipioLoading = false))
    },
    searchLocalidad (val) {
      if (val == null || this.municipio==null || val.length < 2) return
      if (this.localidadLoading) return
      this.localidadLoading = true
      fetch(`${this.server_api}/municipios/${this.municipio.id}/localidades?search=${val}`)
        .then(res => res.json())
        .then(res => {
          this.localidades = res
        })
        .catch(err => {
          //console.log(err)
        })
        .finally(() => (this.localidadLoading = false))
    },
    evento(val) {
        if (val == null) return;
        axios.get(`${this.server_api}/eventos/${this.evento.id}/servicios`).then(result => { this.servicios = result.data; }).catch(error => swal('Oops !', 'No pudimos cargar los servicios.' + error.response.data, 'error'));
    },
  },
  methods: {
      actualizarPersona() {
        if (!this.$refs.formasistencia.validate()) {
          return;
        }
        axios.put(`${this.server_api}/jornadas/preregistro/${this.persona.id}`, {
            servicio_id: this.servicio.id,
            municipio_id: this.municipio.id,
            localidad_id: this.localidad.id || null,
            curp : this.persona.curp,
            fecha_nacimiento: this.persona.fechaNacimiento,
            telefono : this.persona.telefono,
            observacion: this.observacion
        }).then(response => {
            swal('Great!', 'Actualizado correctamente', 'success');
            this.persona.id = null
           this.persona.nombre = null
           this.persona.primerApellido = null
           this.persona.segundoApellido = null
           this.persona.curp = null
           this.persona.fechaNacimiento = null
           this.persona.telefono = null
           this.municipio = null
           this.localidad = null
           this.obervacion = null
           this.$refs.formasistencia.resetValidation()
        }).catch(error => { swal('Oops!', 'No se actualizo', 'error') });
      },
      obtenFecha() {
        if(this.persona.curp.length >= 10){
          this.persona.fechaNacimiento = `19${this.persona.curp.substring(4,6)}/${this.persona.curp.substring(6,8)}/${this.persona.curp.substring(8,10)}`
        }
      }
  },
  mounted() {
    axios.get(`${this.server_api}/eventos?tipo=JORNADA`).then(response => { this.eventos = response.data; }).catch(error => { swal('Oops', 'No se pudieron cargar los eventos. ' + error, 'error')});
  }
}
</script>

<style scoped>
  .evento{
    width: 100%;
    height: 100%;
  }
</style>